import React, { Component } from 'react';
import './strategy.css';
import { Link } from 'react-router-dom';

class Strategy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      strats : [],
      mapActive: false                  
    };
  }

  componentDidMount() {
    this.getStrat();
  }

  checkScroll = (e) => {  
    var scrollY = e.target.scrollTop;
    // console.log('scroll')
    if ((scrollY > 500 ) && (this.state.mapActive === false)) {
      // console.log('yo')
      var map = document.getElementById('dualMap')
      if(map){
        map.classList.add('activeMap')
        this.setState({mapActive: true})
      }
    }
  }

  // Retrieves the list of items from the Express app
  getStrat = () => {
    fetch('/api/strategy')
    .then(res => res.json())
    .then(data => this.setState({ strats: data.strats }, () => {
      var stratSec = document.getElementById('stratSec')
      if(stratSec){
        stratSec.addEventListener('scroll', this.checkScroll)
      }
    }));
  }

  render() {
    const { strats } = this.state;
        
    return (
      <React.Fragment>
        {strats.length ? (
          <div className="mapContent fullStage hoverRed stratContent" style={{"opacity": this.props.mapVis[4]}} >
            <Link to="/dual-power-map">
              <div id="dualMap" className="dualPower bgCover">
                <img src="images/dualpower.gif" alt="Dual Power Icon"></img>
              </div>
            </Link> 
            {strats.map((strats, i) => {
              return(
                <React.Fragment key={i}>
                  <div className="centerT marginBotLarge stratIntro" dangerouslySetInnerHTML={{ __html : strats.stratIntro }}></div>
                  <h1 className="tfStage marginBotLarge visHeader" dangerouslySetInnerHTML={{ __html : strats.stratVisLead }}></h1>
                  <ul className= "marginBotLarge visionList">
                    <li className="tfStage"><div dangerouslySetInnerHTML={{ __html : strats.stratVis1 }}></div></li>
                    <li className="tfStage"><div dangerouslySetInnerHTML={{ __html : strats.stratVis2 }}></div></li>
                    <li className="tfStage"><div dangerouslySetInnerHTML={{ __html : strats.stratVis3 }}></div></li>
                    <li className="tfStage"><div dangerouslySetInnerHTML={{ __html : strats.stratVis4 }}></div></li>
                  </ul>
                  <div className="stratVisCopy" dangerouslySetInnerHTML={{ __html : strats.stratVisCopy }}></div>
                </React.Fragment>
              );
            })}
          </div>
        ) : (
          <div className="fullWidth fullHeight redT blinkFast loader">
            <div className="centeredContent">•</div>
          </div>
        )}
      </React.Fragment>
    )
  }
}

export default Strategy


// WEBPACK FOOTER //
// ./src/components/strategy/strategy.js